import { Component, Input, OnInit } from '@angular/core';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import { ApiSearchRequestTable } from '../../models/api-search-request-table';
import { UserApiService } from '../../services/user-api.service';
import { LoggerService } from 'src/app/services/logger.service';
import { Router } from '@angular/router';

@Component({
  selector: '<notification>',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.css'],
})
export class NotificationComponent implements OnInit {
  constructor(
    private logger: LoggerService,
    private router: Router,
    private apiService: UserApiService
  ) {
    this.isRTL = true;
  }
  public loading: boolean = true;
  public pageConfig: any;
  public apiResponse?: any[];
  public unreadCount: number = 0;

  @Input() isRTL: boolean;

  public ngOnInit(): void {
    this.fetchData();
  }

  public fetchData() {
    try {
      this.loading = true;

      let url = `Notification?pageNumber=1&pageSize=1000&paging=false&orderBy=&direction=asc`;

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      // [check, ExpireDate, NeedToBuy, Event, Update];
      const sortOrder = [1, 3, 4, 2, 0];

      this.apiService.getWitoutPage(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);

          if (result.succeeded) {
            this.apiResponse = result
              .data!.filter((current) => current.notificationType != 0)
              .sort((a, b) => {
                if (a.isRead !== b.isRead) {
                  return a.isRead - b.isRead;
                }
                return (
                  sortOrder.indexOf(a.notificationType) -
                  sortOrder.indexOf(b.notificationType)
                );
              });

            const updateAlert = result.data!.filter(
              (current) => current.notificationType == 0
            );

            updateAlert.forEach((element) => {
              this.logger.addInfo(element.description, false);
            });

            this.unreadCount = this.apiResponse.filter(
              (current) => current.isRead == false
            ).length;
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
        },
        () => { }
      );
    } catch (e) {
      this.logger.addException(e, true);
    }
  }

  public closeItem(item: any, id: number) {
    this.apiResponse?.splice(id, 1);
    if (!item.isRead) {
      this.submitEdit(item);
    }
  }

  public submitEdit(inputElement: any) {
    try {
      this.loading = true;

      const url = `Notification/SetRead/${inputElement.id}`;

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getWitoutPage(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          if (result.succeeded) {
            this.unreadCount--;
            this.logger.addInfo(
              'وضعیت اعلان به دیده شده تغییر پیدا کرد',
              false
            );
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
        },
        () => { }
      );
    } catch (e) {
      this.logger.addException(e, true);
    }
  }

  public clearList() {
    this.apiResponse = [];
  }
}
